<style lang="stylus">
    .ImportData-mask
        modal-mask()
        .ImportData-modal
            width 360px

            .ImportData-container
                color: var(--text-color-primary);
                display flex
                justify-content space-between
                .ImportData-imgbox
                    width 144px
                    height 144px
                    border 1px solid $box-bordercolor
                    border-radius 6px
                    cursor pointer
                    user-select none
                    &:hover{
                      background-color: var(--bg-color-import-data-item-hover);
                    }
                    p
                        height 32px
                        line-height 32px
                        text-align center
                        border-bottom 1px solid $box-bordercolor
                    .img-box{
                      height: 144px - 32px
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      img{
                        height: 67px
                        object-fit contain
                      }
                    }
</style>

<template>
    <div class="ImportData-mask">
        <Dialog class="ImportData-modal" :title="$t('title')" :isShow="true">
            <div class="ImportData-container">
                <div class="ImportData-imgbox" v-for="item in imgList" @click="importClick(item.id)">
                    <p>{{ $t(item.name) }}</p>
                    <div class="img-box">
                        <img :src="item.url" alt="" />
                    </div>
                </div>
                <input ref="excelInput" accept=".xlsx,.csv" type="file" style="display: none" @change="importExcel($event)" />
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    declare var eFlagExcelImport: any;

    @Component({
        components: {
            Dialog,
        },
    })
    export default class ImportData extends Vue {
        @Inject()
        ["showMessage"];

        imgList: Array<object> = [
            {
                id: 0,
                name: "orgchart",
                url: require("@/app/assets/img/insert/data/orgchart.png"),
            },
            {
                id: 1,
                name: "table",
                url: require("@/app/assets/img/insert/data/table.png"),
            },
            // {
            //     id: 2,
            //     name: 'gantt',
            //     url: require('@/app/assets/img/insert/data/gantt.png')
            // }
        ];
        importClick(id) {
            if (id == 0) {
                // 导入orgchart
                this.$track("modal", "file", "import data orgchart");
                this.$store.commit("setDialogState", {
                    type: "dialogType",
                    data: "OrgChartImport",
                });
            } else {
                // 导入table
                this.$track("modal", "file", "import data table");
                (this.$refs.excelInput as HTMLInputElement).click();
            }
        }
        getTotalRowLine(data) {
            let row = 0,
                line = 0;
            for (let i = 0; i < data.length; i++) {
                row = i + 1;
                if (data[i]) {
                    let length = data[i].length;
                    line = line > length ? line : length;
                }
            }
            return { row, line };
        }
        importExcel(e) {
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = (e) => {
                let importExcelData = [];
                let res = window["_view"].chartImportFromExcel((e.target as any).result, importExcelData);
                if (res === eFlagExcelImport.MulPage) {
                    let msg = this.$t("ExcelTable.MulPage");
                    this.showMessage({
                        type: 2,
                        content: msg,
                    });
                }
                let a = this.getTotalRowLine(importExcelData);

                window["_view"].createTableByImportData(a.row, a.line, importExcelData);
                this.$store.commit("setDialogState", {
                    type: "showDialog",
                    data: false,
                });
                (this.$refs.excelInput as HTMLInputElement)["value"] = "";
            };
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "导入数据",
    "orgchart": "组织结构图",
    "table": "表格",
    "gantt": "甘特图",
    "MulPage": "检测到多页文档，正在导入第一页文档"
  },
  "en": {
    "title": "Import Data",
    "orgchart": "Orgchart",
    "table": "Table",
    "gantt": "Gantt",
    "MulPage": "Detecting multi-page document，importing the first page."
  },
  "jp": {
    "title": "データをインポート",
    "orgchart": "組織図",
    "table": "表",
    "gantt": "ガントチャート",
    "MulPage": "複数ページのドキュメントが検出され、最初のページをインポートしています"
  },
  "fr": {
    "title": "Importer des données",
    "orgchart": "Organigramme",
    "table": "Table",
    "gantt": "Gantt",
    "MulPage": "Détection d'un document multipage ， importation de la première page."
  },
  "de": {
    "title": "Daten importieren",
    "orgchart": "Organigramm",
    "table": "Tabelle",
    "gantt": "Balkendiagramm",
    "MulPage": "Erkennen eines mehrseitigen Dokuments, importieren der ersten Seite"
  },
  "es": {
    "title": "Importar datos",
    "orgchart": "Orgchart",
    "table": "Mesa",
    "gantt": "Gantt",
    "MulPage": "Detección de multipágina document，importing la primera página"
  },
  "pt": {
    "title": "Importar Dados",
    "orgchart": "Organograma",
    "table": "Tabela",
    "gantt": "Gantt",
    "MulPage": "Detectando documento de múltiplas páginas, importando a primeira página."
  },
  "it": {
    "title": "Importa Dati",
    "orgchart": "Organigramma",
    "table": "Tabella",
    "gantt": "Gantt",
    "MulPage": "È stato rilevato un documento con più pagine. Verrà importata la prima pagina."
  },
  "tw": {
    "title": "導入數據",
    "orgchart": "組織結構圖",
    "table": "表格",
    "gantt": "甘特圖",
    "MulPage": "檢測到多頁檔案，正在導入第一頁檔案"
  },
  "kr": {
    "title": "데이터 가져오기",
    "orgchart": "조직도",
    "table": "표",
    "gantt": "간트 차트",
    "MulPage": "여러 페이지 문서가 감지되었습니다. 첫 페이지 가져오는 중"
  }
}
</i18n>
